/**
 * Centraliza el acceso a variables de entorno. Cualquier `import.meta.env.VITE_*`
 * debe pasar por aquí — facilita tipado, defaults y testing.
 */
export const ENV = {
  mode: import.meta.env.VITE_APP_MODE ?? "connected",
  backendUrl: import.meta.env.VITE_BACKEND_URL ?? "/api/v1",
  telemetryEnabled: import.meta.env.VITE_TELEMETRY_ENABLED !== "false",
  oauth: {
    provider: import.meta.env.VITE_OAUTH_PROVIDER ?? "",
    clientId: import.meta.env.VITE_OAUTH_CLIENT_ID ?? "",
  },
  buildHash: typeof __APP_BUILD_HASH__ !== "undefined" ? __APP_BUILD_HASH__ : "dev",
  buildTime: typeof __APP_BUILD_TIME__ !== "undefined" ? __APP_BUILD_TIME__ : new Date().toISOString(),
} as const;

declare const __APP_BUILD_HASH__: string;
declare const __APP_BUILD_TIME__: string;
